import React from 'react';
import { Chip } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

//수주품의,발주, 세금계산서, 채권, 수주실패
const CmpStatusChip = (params) => {
  let label = '';
  let color = '';

  if (params.row === undefined) {
    label = '수주실패';
    color = 'default';

  } else if (params.row.useYn === 'Y') {

    switch (params.row.cmpGrade) {
      case '0':
        label = '수주품의';
        color = 'secondary';
        break;
      case '1':
        label = '발주';
        color = 'success';
        break;
      case '2':
        label = '세금계산서';
        color = 'error';
        break;
      case '3':
        label = '채권';
        color = 'info';
        break;

      default:
        break;
    }
  } else {
    color = 'default';
    label = '수주실패';
  }

  return (
    <Chip
      size="small"
      icon={<CircleIcon />}
      label={label}
      variant="outlined"
      color={color}
    />
  );
};

export default CmpStatusChip;
